export default __webpack_public_path__ + "static/media/795.0e949475.png";